import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Hide16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M15.3578 5.92758C15.6739 6.12516 15.77 6.5416 15.5724 6.85773C15.1581 7.5207 14.671 8.12859 14.1204 8.66579L15.195 9.74037C15.4586 10.004 15.4586 10.4314 15.195 10.695C14.9314 10.9586 14.504 10.9586 14.2404 10.695L13.0836 9.53813C12.3474 10.0689 11.5299 10.4878 10.6465 10.7689L11.0521 12.2824C11.1485 12.6425 10.9348 13.0127 10.5747 13.1091C10.2147 13.2056 9.84453 12.9919 9.74805 12.6318L9.33108 11.0755C8.89919 11.141 8.45502 11.175 8.00004 11.175C7.54505 11.175 7.10088 11.141 6.66899 11.0755L6.25205 12.6318C6.15558 12.9919 5.78546 13.2056 5.42536 13.1091C5.06527 13.0127 4.85156 12.6425 4.94804 12.2825L5.35354 10.7689C4.47014 10.4877 3.65267 10.0689 2.91648 9.53811L1.75963 10.695C1.49602 10.9586 1.06864 10.9586 0.805032 10.695C0.541428 10.4314 0.541428 10.004 0.805032 9.74036L1.87963 8.66577C1.32907 8.12858 0.841997 7.52069 0.427643 6.85773C0.230063 6.5416 0.326164 6.12516 0.642291 5.92758C0.958418 5.73 1.37486 5.8261 1.57244 6.14223C2.04149 6.89271 2.61327 7.5557 3.2702 8.10491C3.28355 8.11518 3.29661 8.12601 3.30933 8.13741C4.59476 9.19779 6.20156 9.82497 8.00004 9.82497C10.7407 9.82497 13.0362 8.36858 14.4276 6.14223C14.6252 5.8261 15.0417 5.73 15.3578 5.92758Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
